<template>
  <div class="animated fadeIn">
   
    <b-row> 
      <b-col sm="12">
        <b-card header-tag="header" footer-tag="footer">
          <div slot="header">
            <strong>CDM Deposit</strong> 

          </div>


          <b-row>
           <b-col md="12" >
    
           <div>
            <ul class="nav nav-tabs nav-justified">
             
             

              <li class="nav-item">
                <a @click="activeTab = 1"  class="nav-link" :class="{'active' : isActiveTab(1)}" >Pending</a>
              </li>

              <li class="nav-item">
                <a @click="activeTab = 2"  class="nav-link " :class="{'active' : isActiveTab(2)}">Approved</a>
              </li>
              <li class="nav-item">
                <a @click="activeTab = 3"  class="nav-link" :class="{'active' : isActiveTab(3)}" >Rejected</a>
              </li>
              <li class="nav-item">
                <a @click="activeTab = 4"  class="nav-link" :class="{'active' : isActiveTab(4)}" >Feedback</a>
              </li>
             
            </ul>
          </div>
           
          </b-col>
          <b-col md="12" >
       

            <div class="tab-panel" v-if="isActiveTab(1)">
            <cdmpending style="width:70%;"></cdmpending>
            </div>

            <div class="tab-panel" v-if="isActiveTab(2)">
              <cdmapprove style="width:70%;"></cdmapprove>
            </div>

            <div class="tab-panel" v-if="isActiveTab(3)">
            <cdmreject style="width:70%;" ></cdmreject>
            </div>
            <div class="tab-panel" v-if="isActiveTab(4)">
            <cdmfeedback style="width:70%;" ></cdmfeedback>
            </div>
     
        
             </b-col>

          </b-row> 
        </b-card>
       
      </b-col>
    </b-row> 
  </div>   


</template>
<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";




import cdmpending from './cdmpending.vue'
import cdmapprove from './cdmapprove.vue'

import cdmreject from './cdmreject.vue'
import cdmfeedback from './cdmfeedback.vue'

export default {
  data: function() {
    return {
      // activeTab: '',
      activeTab: 1,
      cdmpending,
      cdmapprove,
      cdmreject,
      cdmfeedback,
      name: 'CDM Deposit'
     
    };
  },
  components: {
   

    cdmpending,
    cdmapprove,
    cdmreject,
    cdmfeedback

  },
 created: function() {
    this.isActiveTab(1);
  },
 
  methods: {
    isActiveTab(id)

    {
      
       return this.activeTab === id
    },



    

  },
  filters: {
    capitalize: function(value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  }




  

};
</script>
